/** Shared membership helpers. */

export function memberBalance(m) {
    if (m?.balance_due != null) return Number(m.balance_due) || 0;
    if (m?.total_due != null && m?.total_paid != null) {
        return Math.max(0, Number(m.total_due) - Number(m.total_paid));
    }
    return 0;
}

/** Pick the membership with the largest balance still due. */
export function pickDueMembership(memberships = []) {
    const due = memberships.filter((m) => memberBalance(m) > 0);
    if (!due.length) return null;
    return due.sort((a, b) => memberBalance(b) - memberBalance(a))[0];
}

/** All receipt invoices for a membership (initial + installments). */
export function listMembershipReceipts(membership) {
    const seen = new Set();
    const rows = [];
    const add = (invoiceId, invoiceNumber) => {
        if (!invoiceId || seen.has(invoiceId)) return;
        seen.add(invoiceId);
        rows.push({ invoiceId, invoiceNumber: invoiceNumber || "Receipt" });
    };
    for (const p of membership?.payments || []) {
        add(p.invoice_id, p.invoice_number);
    }
    add(membership?.invoice_id, membership?.invoice_number);
    return rows;
}
